"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyDocMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const company_entity_1 = require("./company.entity");
const file_upload_entity_1 = require("./file-upload.entity");
let CompanyDocMap = class CompanyDocMap {
    constructor(companyId, documentId) {
        this.companyId = companyId;
        this.documentId = documentId;
    }
};
exports.CompanyDocMap = CompanyDocMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], CompanyDocMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], CompanyDocMap.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "doc_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], CompanyDocMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => company_entity_1.Company, (company) => company.companyDocMaps, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "company_id" }),
    tslib_1.__metadata("design:type", Object)
], CompanyDocMap.prototype, "company", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload, (fileupload) => fileupload.companyDocMaps, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "doc_id" }),
    tslib_1.__metadata("design:type", Object)
], CompanyDocMap.prototype, "document", void 0);
exports.CompanyDocMap = CompanyDocMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("company_doc_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number])
], CompanyDocMap);
